import { render, staticRenderFns } from "./ReminderDetailsModal.vue?vue&type=template&id=31d56078&scoped=true"
import script from "./ReminderDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReminderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ReminderDetailsModal.vue?vue&type=style&index=0&id=31d56078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d56078",
  null
  
)

export default component.exports